// src/pages/UtahFunFacts.jsx
import React from "react";
import { motion } from "framer-motion";
import {
  FaTree,
  FaCrow,
  FaMountain,
  FaFeather,
  FaSnowflake,
  FaSun,
  FaCity,
  FaHiking,
  FaSeedling,
  FaHorse,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const facts = [
  {
    icon: <FaTree className="text-green-600 text-3xl" />,
    title: "State Tree: Quaking Aspen",
    text: "Utah is home to 'The Trembling Giant', a single Quaking Aspen that covers 106 acres and weighs more than 6,000 metric tons.",
  },
  {
    icon: <FaCrow className="text-gray-600 text-3xl" />,
    title: "State Bird: California Gull",
    text: "Credited with saving Mormon pioneers' first crops. Honored as the Utah state bird.",
  },
  {
    icon: <FaMountain className="text-indigo-600 text-3xl" />,
    title: "Life Elevated",
    text: "Utah’s slogan. Highest point is Kings Peak (13,528 ft). Lowest is Beaver Dam Wash (2,000 ft).",
  },
  {
    icon: <FaFeather className="text-yellow-600 text-3xl" />,
    title: "State Flower: Sego Lily",
    text: "Chosen for its natural beauty & historical role feeding pioneers during hard times.",
  },
  {
    icon: <FaSnowflake className="text-blue-400 text-3xl" />,
    title: "Salt Lake City",
    text: "State capital with over 200,000 residents. Known as 'The City With Wilderness on the Edge' (John Muir).",
  },
  {
    icon: <FaSun className="text-orange-500 text-3xl" />,
    title: "Beehive State",
    text: "Symbol of industry & perseverance. Beehive emblem adopted in 1848, still used today.",
  },
  {
    icon: <FaCity className="text-purple-600 text-3xl" />,
    title: "State Mammal: Rocky Mountain Elk",
    text: "Majestic elk roam proudly from border to border of Utah.",
  },
  {
    icon: <FaHiking className="text-red-500 text-3xl" />,
    title: "Wasatch Range",
    text: "160-mile stretch from Utah-Idaho border to central Utah. Part of the Rocky Mountains.",
  },
  {
    icon: <FaSeedling className="text-green-500 text-3xl" />,
    title: "National Parks",
    text: "Utah has 5 national parks — Zion, Bryce, Capitol Reef, Arches, Canyonlands. Known as the Mighty 5.",
  },
  {
    icon: <FaHorse className="text-brown-600 text-3xl" />,
    title: "State Name",
    text: "‘Utah’ comes from the Ute tribe, meaning 'people of the mountains'.",
  },
];

export default function UtahFunFacts() {
  return (
    <div>
        <Header/>
    <div className="min-h-screen mt-[8rem] bg-gradient-to-b from-sky-100 via-white to-amber-100 p-6 md:p-12">
      {/* Header */}
      <motion.h1
        className="text-4xl md:text-5xl font-bold text-center mb-12 text-indigo-800"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        🌄 Utah Fun Facts
      </motion.h1>

      {/* Facts Grid */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {facts.map((fact, i) => (
          <motion.div
            key={i}
            className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200 hover:shadow-2xl transform hover:-translate-y-2 transition-all cursor-pointer"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1, duration: 0.6 }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="flex items-center gap-3 mb-3">
              {fact.icon}
              <h2 className="text-lg font-semibold text-gray-800">{fact.title}</h2>
            </div>
            <p className="text-gray-600 text-sm">{fact.text}</p>
          </motion.div>
        ))}
      </div>

      {/* Footer */}
      <p className="text-center text-gray-500 mt-12 text-sm">
        ✨ Discover Utah’s beauty & heritage ✨
      </p>
    </div>
    <Footer/>
    </div>
  );
}
